import { State } from '../../types';

export const oregon: State = {
  name: 'Oregon',
  abbreviation: 'OR',
  terms: [
    {
      word: 'Aloha',
      phonetic: 'uh-LOW-uh',
      // audioUrl: '/audio/aloha.mp3',
      description: 'A community west of Portland, pronounced differently from the Hawaiian greeting.'
    },
    {
      word: 'Champoeg',
      phonetic: 'sham-POO-ee',
      // audioUrl: '/audio/champoeg.mp3',
      description: 'A historic area significant for early Oregon governance.'
    },
    {
      word: 'Chautauqua',
      phonetic: 'shuh-TAH-kwuh',
      // audioUrl: '/audio/chautauqua.mp3',
      description: 'A street in Portland, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Clackamas',
      phonetic: 'CLACK-uh-muss',
      // audioUrl: '/audio/clackamas.mp3',
      description: 'A county and river in Oregon, with a name of Native American origin.'
    },
    {
      word: 'Coquille',
      phonetic: 'ko-KEEL',
      // audioUrl: '/audio/coquille.mp3',
      description: 'A city and river in southwestern Oregon.'
    },
    {
      word: 'Couch Street (Portland)',
      phonetic: 'KOOCH',
      audioUrl: '/audio/willamette.mp3',
      description: "If it feels naughty, you're saying it right. a street in downtown Portland, often mispronounced as Couch (like a sofa)."
    },
    {
      word: 'Deschutes',
      phonetic: 'duh-SHOOTS',
      // audioUrl: '/audio/deschutes.mp3',
      description: 'A county and river in Oregon, with a name derived from French.'
    },
    {
      word: 'Glisan',
      phonetic: 'GLEE-sun',
      // audioUrl: '/audio/glisan.mp3',
      description: 'A street in Portland, often mispronounced due to its spelling.'
    },
    {
      word: 'Helvetia',
      phonetic: 'hel-VAY-sha',
      // audioUrl: '/audio/helvetia.mp3',
      description: 'A community in Washington County, named after the Latin name for Switzerland.'
    },
    {
      word: 'Langlois',
      phonetic: 'LANG-loyce',
      // audioUrl: '/audio/langlois.mp3',
      description: 'A community in Curry County, with a pronunciation that rhymes with "Joyce."'
    },
    {
      word: 'Madras',
      phonetic: 'MAD-russ',
      // audioUrl: '/audio/madras.mp3',
      description: 'A city in Jefferson County, pronounced with emphasis on the first syllable.'
    },
    {
      word: 'Molalla',
      phonetic: 'moe-LAH-lah',
      // audioUrl: '/audio/molalla.mp3',
      description: 'A city in Clackamas County, named after the Molalla River.'
    },
    {
      word: 'Multnomah',
      phonetic: 'mult-NO-mah',
      // audioUrl: '/audio/multnomah.mp3',
      description: 'A county and neighborhood in Portland, with a name of Native American origin.'
    },
    {
      word: 'Philomath',
      phonetic: 'fill-OH-muth',
      // audioUrl: '/audio/philomath.mp3',
      description: 'A city in Benton County, with a name meaning "lover of learning."'
    },
    {
      word: 'Scio',
      phonetic: 'SIGH-oh',
      // audioUrl: '/audio/scio.mp3',
      description: 'A city in Linn County, pronounced with two syllables.'
    },
    {
      word: 'Siletz',
      phonetic: 'sill-ETZ',
      // audioUrl: '/audio/siletz.mp3',
      description: 'A city and river in Lincoln County, with a name of Native American origin.'
    },
    {
      word: 'Siuslaw',
      phonetic: 'sigh-YEW-slaw',
      // audioUrl: '/audio/siuslaw.mp3',
      description: 'A river and national forest in western Oregon.'
    },
    {
      word: 'Tigard',
      phonetic: 'TIE-gurd',
      // audioUrl: '/audio/tigard.mp3',
      description: 'A city in Washington County, pronounced with emphasis on the first syllable.'
    },
    {
      word: 'Tualatin',
      phonetic: 'too-AWL-uh-tin',
      // audioUrl: '/audio/tualatin.mp3',
      description: 'A city and river in Washington County, with a name of Native American origin.'
    },
    {
      word: 'Willamette',
      phonetic: 'will-AM-it',
      // audioUrl: '/audio/willamette.mp3',
      description: 'A river and valley in western Oregon, with a name believed to mean "still water."'
    },
    {
      word: 'Yachats',
      phonetic: 'YAH-hots',
      // audioUrl: '/audio/yachats.mp3',
      description: 'A coastal city in Lincoln County, with a name of Native American origin.'
    },
    {
      word: 'Yaquina',
      phonetic: 'ya-KWINN-ah',
      // audioUrl: '/audio/yaquina.mp3',
      description: 'A bay, river, and head in Lincoln County, with a name of Native American origin.'
    }
  ]
};